const Nav = () => {
    return ( 
        <div className="header-bar-wrapper">
            <div className="container">
                <div className="hb-content">
                    <a href="/" className="logo-header">
                        <img src="\assets\KSH3nA_A.png" alt="homes for life" className="logo" />
                    </a>
                     
                    <a href="/Quote" className="btn-header">
                        Get Quote
                    </a>
                </div>
            </div>
        </div>
     );
}
 
export default Nav;